import Header from '../components/Header';
import Footer from '../components/Footer';
import { Outlet } from 'react-router-dom';
import { SidebarProvider, useSidebar } from "../context/SidebarContext";
import Sidebar from '../components/Sidebar';
import { useState } from 'react';

const MainLayout = () => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    return (
        <SidebarProvider>
            <div className="main-layout">
                <Header />
                <Sidebar isOpen={isSidebarOpen} onClose={() => setSidebarOpen(false)} />
                <Outlet />
                {/* <gecko-coin-price-marquee-widget
  locale="en"
  outlined="true"
  coin-ids="bitcoin,ethereum,binancecoin,solana,ripple,cardano,dogecoin,the-open-network"
  initial-currency="usd"
/> */}
                <Footer />
            </div>
        </SidebarProvider>
    )
}

export default MainLayout